import {
  discountSectionExistsInCurrentWizardSelections,
  getDepositAmount, getDepositForCurrentQuote,
  shouldUseMultipleWorkSheets,
} from "./discountFunctions";
import {getQuotePriceWithTaxes, getTotalPrice, toFixedPrice} from "../../misc/helpers";
import {DISCOUNT_MAIN_TYPES} from "./discounstInterface";

/**
 * @param storeState {object}  //careful this is not the full store in some cases
 * @param discountType {string}
 * @param forQuoteIndex {number|null}
 * @returns {{neededDiscount: discountInterface, neededDiscountSection: discountSectionsInterface}}
 * */
export const getSpecificDiscount = (storeState, discountType, forQuoteIndex = null) => {
  const {priceWorksheetState, wizardState} = storeState;
  const {discountSections} = priceWorksheetState;
  let neededDiscount = null;
  let neededDiscountSection = null;
  discountSections.forEach(sec => {
    if (neededDiscount) return;
    if (Number.isInteger(forQuoteIndex) && shouldUseMultipleWorkSheets(priceWorksheetState.workSheetsCount) && !discountSectionExistsInCurrentWizardSelections(
      sec,
      wizardState.allWizardsValues,
      forQuoteIndex)) {
      return;
    }
    sec.discounts.forEach(discount => {
      if (neededDiscount) return;
      if (discount.discountType === discountType) {
        neededDiscount = discount;
        neededDiscountSection = sec;
      }
    })
  });
  return {neededDiscount, neededDiscountSection}
}


/**
 * @param store {object} //careful this is not the full store in some cases
 * @param forQuoteIndex {number|null}
 * @returns {number}
 * */
export const getFinancedAmount = (store, forQuoteIndex = null) => {
  const {discountSections} = store.priceWorksheetState;
  if (!discountSections || !discountSections.length) {
    return 0;
  }
  return store.quotesState.quotes.reduce((total, quote , quoteIndex) => {
    if (Number.isInteger(forQuoteIndex) && quoteIndex !== forQuoteIndex) {
      return total
    }
    const depositForCurrentQuote = getDepositForCurrentQuote(discountSections,
      store.wizardState.allWizardsValues,
      quoteIndex,
      true,
      DISCOUNT_MAIN_TYPES.financedAmount
    );
    if (depositForCurrentQuote !== null) {
      return (total || 0) + depositForCurrentQuote
    }
    return total
  }, null)
}

/**
 * @param store {object}
 * @param discountSection {discountSectionsInterface}
 * @param discount {discountInterface}
 * @param quoteIndex {number}
 * @returns {number}
 * */
export const getBalanceDueAmount = (store, discountSection = null, discount = null, quoteIndex = null) => {

  if (!discountSection || !discount) {
    const {neededDiscount, neededDiscountSection} = getSpecificDiscount(store, DISCOUNT_MAIN_TYPES.balanceDue, quoteIndex);
    if (neededDiscount) {
      discount = neededDiscount;
      discountSection = neededDiscountSection;
    } else { // just in case
      return 0;
    }
  }

  const {discountSections, financeActiveDiscount} = store.priceWorksheetState;
  // const {allWizardsValues} = store.wizardState;
  const fabricatorData = store.fabricatorState;

  const totalPrice = Number.isInteger(quoteIndex) ? getTotalPrice(quoteIndex) : getTotalPrice();
  const grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

  const depositAmount = getDepositAmount(discountSections, grandTotal, fabricatorData, quoteIndex) || 0;
  //
  // const {discountSubTotalWithTaxes} = getDiscountSubTotalPrice(
  //   discountSections,
  //   discountSection,
  //   discount,
  //   false,
  //   customAddedDiscounts,
  //   quoteIndex,
  //   hasMultipleWorkSheets,
  // );

  const financedAmount = financeActiveDiscount ? getFinancedAmount(store, quoteIndex) : 0;
  const balanceDueValue = +grandTotal - depositAmount - financedAmount;

  return +toFixedPrice(balanceDueValue);
}
